export default __webpack_public_path__ + "static/media/settings_room_device_brightness.5f401b84.svg";